import React, { useState } from "react";
import { useRequestProcessor } from "../../requestProcessor";
import { useAtom } from "jotai";
import {
  activeChildDetail,
  requestType,
  TabsAtom,
} from "../../AtomStore/store";

import {
  fetchPastRequests,
  fetchRequestTypes,
} from "../../QueryFunctions/queryfunction";
import Tiles from "./components/Tiles";
import SpinnerLoading from "../../Components/utils/SpinnerLoading";

import { Link } from "react-router-dom";
import { FaRegListAlt } from "react-icons/fa";
import PastRequestItem from "./pastRequest/PastRequestItem";

const Support = () => {
  const { useQueryWrapper } = useRequestProcessor();
  const [, setType] = useAtom(requestType);
  const [, setAllowedServices] = useState([]);
  const [tabs, setTabs] = useAtom(TabsAtom);
  const [activeChild] = useAtom(activeChildDetail);
  let [pendingList, setPendingList] = useState([]);
  // useEffect(() => {
  //   console.log(
  //     '[Support] Fetching support information for child:',
  //     activeChild?.id
  //   );
  // }, []);

  const { isLoading, refetch } = useQueryWrapper(
    ["pastRequest", "pastRequest" + activeChild?.id],
    () => {
      console.log("[Support] Calling API: /parentapp/requestList", {
        child_id: activeChild?.id,
      });

      return fetchPastRequests();
    },
    {
      onSuccess: (data) => {
        if (Array.isArray(data)) {
          let Pending = data.filter((item) => {
            return item.status === "Pending" && item.type !== "Child Resume";
          });
          setPendingList(Pending);
        }
        console.log("[Support] Received past requests:", pendingList);
      },
    }
  );

  const { isFetching } = useQueryWrapper(
    ["getRequestType", activeChild?.id],
    () => {
      console.log("[Support] Calling API: /parentapp/getRequestTypes", {
        child_id: activeChild?.id,
      });
      return fetchRequestTypes(setAllowedServices, setType, setTabs);
    },
    {
      onSuccess: (data) => {
        console.log("[Support] Received request types:", data);
      },
    }
  );

  console.log("tabs", tabs);
  return (
    <div className="mx-2 mb-20">
      {isFetching || isLoading ? <SpinnerLoading /> : ""}
      <div className="mb-4 mt-3">
        {Array.isArray(pendingList) && pendingList.length > 0 && (
          <>
            <h2 className="text-black font-semibold mb-2 ml-2 text-lg">
              Recent Past Requests
            </h2>
            {pendingList.map((item, index) => (
              <PastRequestItem
                md={6}
                item={item}
                key={index}
                index={index}
                refetch={refetch}
              />
            ))}
          </>
        )}
      </div>

      <div className="hidden md:flex md:gap-2 md:block">
        <div className=" grid grid-cols-12 gap-1  h-18  bg-header w-full shadow-md  rounded-lg p-2 mt-2">
          <div className="col-span-4 flex items-center justify-center">
            {" "}
            <FaRegListAlt className="text-white text-4xl " />
          </div>
          <Link
            to="/PastRequestTab"
            className="col-span-8 flex flex-col justify-center"
          >
            <h3 className="text-base font-semibold text-white ">
              Past Requests
            </h3>
            <h4 className="text-xs text-white">Past Requests</h4>
          </Link>
        </div>
        <div className=" grid grid-cols-12 gap-1  h-18  bg-dark w-full shadow-md  rounded-lg p-2 mt-2">
          <div className="col-span-4 flex items-center justify-center">
            {" "}
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="3em"
              height="3em"
              viewBox="0 0 256 256"
            >
              <path
                fill="white"
                d="M232 104a8 8 0 0 0 8-8V64a16 16 0 0 0-16-16H32a16 16 0 0 0-16 16v32a8 8 0 0 0 8 8a24 24 0 0 1 0 48a8 8 0 0 0-8 8v32a16 16 0 0 0 16 16h192a16 16 0 0 0 16-16v-32a8 8 0 0 0-8-8a24 24 0 0 1 0-48M32 167.2a40 40 0 0 0 0-78.4V64h56v128H32Zm192 0V192H104V64h120v24.8a40 40 0 0 0 0 78.4"
              />
            </svg>
          </div>
          <Link
            to="/raiseAnIssue"
            className="col-span-8 flex flex-col justify-center"
          >
            <h3 className="text-base font-semibold text-white ">
              Raise A Ticket
            </h3>
            <h4 className="text-xs text-white">Raise A Ticket</h4>
          </Link>
        </div>
      </div>

      {/* <h3 className="font-semibold text-lg pt-4">QUICK SERVICES</h3> */}
      <div className="">
        <Tiles allowedServices={tabs} />
      </div>
      {/* <div className="flex justify-between">
        <Link
          to="/PastRequestTab"
          className="font-semibold text-base pt-4 text-header"
        >
          Past Requests
        </Link>
      </div> */}
      <div className="md:hidden">
        <div className=" grid grid-cols-12 gap-1  h-18  bg-header w-full shadow-md  rounded-lg p-2 mt-2">
          <div className="col-span-4 flex items-center justify-center">
            {" "}
            <FaRegListAlt className="text-white text-4xl " />
          </div>
          <Link
            to="/PastRequestTab"
            className="col-span-8 flex flex-col justify-center"
          >
            <h3 className="text-base font-semibold text-white ">
              Past Requests
            </h3>
            <h4 className="text-xs text-white">Past Requests</h4>
          </Link>
        </div>
        <div className=" grid grid-cols-12 gap-1  h-18  bg-dark w-full shadow-md  rounded-lg p-2 mt-2">
          <div className="col-span-4 flex items-center justify-center">
            {" "}
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="3em"
              height="3em"
              viewBox="0 0 256 256"
            >
              <path
                fill="white"
                d="M232 104a8 8 0 0 0 8-8V64a16 16 0 0 0-16-16H32a16 16 0 0 0-16 16v32a8 8 0 0 0 8 8a24 24 0 0 1 0 48a8 8 0 0 0-8 8v32a16 16 0 0 0 16 16h192a16 16 0 0 0 16-16v-32a8 8 0 0 0-8-8a24 24 0 0 1 0-48M32 167.2a40 40 0 0 0 0-78.4V64h56v128H32Zm192 0V192H104V64h120v24.8a40 40 0 0 0 0 78.4"
              />
            </svg>
          </div>
          <Link
            to="/raiseAnIssue"
            className="col-span-8 flex flex-col justify-center"
          >
            <h3 className="text-base font-semibold text-white ">
              Raise A Ticket
            </h3>
            <h4 className="text-xs text-white">Raise A Ticket</h4>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Support;
